import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { pollKeys } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/api";
import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { MemberRow } from "@circle-react/components/PostsV3/PostViewListItem/PostLikesModal/MemberRow";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useInfiniteQueryWrapper } from "@circle-react/hooks/reactQuery/useInfiniteQueryWrapper";
import { flatten } from "lodash";
import { useMemo } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

import type { PollVoteListModalProps } from "./types";

export const PollVoteListModalUIKitComponent = ({
  pollOptionId,
  pollId,
  pollValue,
  percentage,
}: PollVoteListModalProps) => {
  const modal = useModal();
  const { data, isLoading, fetchNextPage, hasNextPage, mapPages } =
    useInfiniteQueryWrapper(
      internalApi.polls.voteList({
        pollId,
        pollOptionId,
        params: {
          per_page: 15,
        },
      }),
      { enabled: !!pollId && !!pollOptionId },
      pollKeys.voteList(pollId, pollOptionId),
    );

  const votes = useMemo(
    () => flatten(mapPages((page: any) => page.records)),
    [mapPages],
  );
  const totalVotesCount = data?.pages[0]?.count;

  return (
    <Modal isOpen={modal.visible} onClose={modal.remove}>
      <Modal.Overlay />
      <Modal.Content shouldCloseOnOutsideClick>
        <Modal.Header>
          <Modal.Title size="sm">{pollValue}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={modal.hide} />
          </Modal.HeaderActions>
        </Modal.Header>
        {!isLoading && (
          <Typography.LabelSm weight="regular">
            <div className="space-x-1 px-5 pb-4 md:px-8">
              <span>{percentage}%</span>
              <span>{t("separator_dot")}</span>
              <span>
                {t("tiptap.extensions.poll.votes", {
                  count: totalVotesCount,
                })}
              </span>
            </div>
          </Typography.LabelSm>
        )}
        <Modal.Body
          id={`post-likes-modal-${pollId}-${pollOptionId}`}
          className="overflow-auto pb-4 pt-0 sm:max-h-80"
        >
          {isLoading ? (
            <LoaderRow />
          ) : (
            <InfiniteScroll
              scrollThreshold={0.75}
              next={fetchNextPage}
              hasMore={hasNextPage || false}
              loader={<LoaderRow />}
              scrollableTarget={`post-likes-modal-${pollId}-${pollOptionId}`}
              dataLength={votes.length}
              className="flex flex-col space-y-4"
            >
              {votes.map(vote => (
                <MemberRow
                  key={vote.id}
                  member={vote.community_member}
                  onNavigate={modal.hide}
                />
              ))}
            </InfiniteScroll>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
